import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { stripDangerousHtml, StripDangerousHtmlOptions } from '@shared/utils/safe-html.util';

@Pipe({
  name: 'safeHtml',
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string | null | undefined, fallback = '', inline = false): SafeHtml {
    const source = value != null && String(value).trim() !== '' ? String(value) : fallback;
    const options: StripDangerousHtmlOptions = { inline: inline === true };
    const cleaned = stripDangerousHtml(source, options);
    const sanitized = this.sanitizer.sanitize(SecurityContext.HTML, cleaned);
    const html = sanitized != null && sanitized !== '' ? sanitized : cleaned;

    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
